import styled from 'styled-components';

import { breakpoints, colors, fontFamily } from '../../ui/variables';

export const ExamReportItemStyle = styled.div`
  background-color: ${colors.mostlyWhite};
  border-radius: 20px;
  padding: 12px 12px 14px;
  width: 100%;

  .exam-report-item-container {
    display: flex;
    flex-wrap: nowrap;
    position: relative;
    width: 100%;

    .exam-report-link {
      cursor: default;
      &.with-report {
        cursor: pointer;
      }
    }

    .glyph-container,
    .glyph-placeholder {
      margin-right: 16px;
      max-width: 60px;
      min-width: 60px;
    }

    .glyph-placeholder {
      background-color: ${colors.lightGrayishBlue};
      border-radius: 50%;
      padding: 16px 0;

      .glyph-placeholder-content {
        ${fontFamily.sourceSansPro.bold};
        color: ${colors.veryPaleBlue};
        display: block;
        font-size: 24px;
        line-height: 28px;
        text-align: center;
      }
    }

    .exam-report-information {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.veryDarkGrayishBlue};
      font-size: 12px;
      line-height: 16px;
      padding-right: 80px;
      cursor: default;

      &.with-report {
        cursor: pointer;
      }

      @media (min-width: ${breakpoints.hd.width}px) {
        align-items: center;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        max-width: calc(100% - 76px - 68px);
        min-width: calc(100% - 76px - 68px);
        padding-right: 0;
      }

      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        ${fontFamily.sourceSansPro.regular};
        font-size: 14px;
        line-height: 18px;
      }

      .exam-report-type,
      .exam-report-medical-registry,
      .exam-report-patient-name,
      .exam-report-date,
      .exam-report-date-registration,
      .exam-report-doctor-name {
        @media (min-width: ${breakpoints.hd.width}px) {
          padding-right: 16px;
        }
      }

      .exam-report-type {
        @media (min-width: ${breakpoints.hd.width}px) {
          max-width: 20%;
          min-width: 20%;
        }
      }

      .exam-report-medical-registry {
        word-break: break-all;
        @media (min-width: ${breakpoints.hd.width}px) {
          max-width: 12%;
          min-width: 12%;
        }
      }

      .exam-report-patient-name {
        @media (min-width: ${breakpoints.hd.width}px) {
          max-width: 18%;
          min-width: 18%;
        }
      }

      .exam-report-doctor-name {
        @media (min-width: ${breakpoints.hd.width}px) {
          max-width: 12%;
          min-width: 12%;
        }
      }

      .exam-report-date {
        display: none;

        @media (min-width: ${breakpoints.hd.width}px) {
          display: block;
          max-width: 13%;
          min-width: 13%;
        }
      }

      .exam-report-date-registration {
        display: none;

        @media (min-width: ${breakpoints.hd.width}px) {
          display: block;
          max-width: 13%;
          min-width: 13%;
        }
      }

      .exam-report-status {
        margin-top: 12px;

        @media (min-width: ${breakpoints.hd.width}px) {
          margin-top: 0;
          max-width: 16%;
          min-width: 16%;
        }
      }
    }

    .exam-report-go-to {
      position: absolute;
      right: 12px;
      top: 12px;

      @media (min-width: ${breakpoints.hd.width}px) {
        display: none;
      }

      .go-to-report-text {
        ${fontFamily.sourceSansPro.bold};
        color: ${colors.softBlue};
        display: inline-block;
        font-size: 10px;
        line-height: 13px;
        text-transform: lowercase;
      }
    }

    .action-buttons-mobile {
      position: absolute;
      right: 12px;
      bottom: 12px;

      @media (min-width: ${breakpoints.hd.width}px) {
        display: none;
      }

      .action-button-with-icon-mobile {
        max-width: 20px;
        min-width: 20px;

        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }

    .exam-report-actions {
      display: none;

      @media (min-width: ${breakpoints.hd.width}px) {
        display: flex;
        justify-content: flex-end;
        max-width: 68px;
        min-width: 68px;
        padding-left: 12px;
      }

      .action-button {
        display: none;

        @media (min-width: ${breakpoints.hd.width}px) {
          align-items: center;
          display: flex;
          justify-content: center;
          max-width: 20px;
          min-width: 20px;

          &:not(:last-child) {
            margin-right: 12px;
          }
        }
      }
    }
  }

  .confirm-report-modal-container {
    padding: 24px 48px 44px 40px;

    .report-modal-title,
    .report-modal-question,
    .report-modal-description,
    .report-modal-actions {
      max-width: 404px;
    }

    .report-modal-title {
      ${fontFamily.sourceSansPro.bold};
      color: ${colors.veryDarkGray};
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 12px;
    }

    .report-modal-question {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.veryDarkGray};
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 12px;
    }

    .report-modal-description {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.veryDarkGray};
      font-size: 12px;
      line-height: 18px;
      margin-bottom: 20px;
    }

    .report-modal-actions {
      display: flex;
      flex-wrap: nowrap;
      width: 100%;

      .modal-action-wrapper {
        flex-basis: calc(50% - 16px);

        &:first-child {
          margin-right: 32px;
        }
      }
    }
  }
`;
